import { Grid, Group, Stack } from "@mantine/core"
import { IconPlus } from "@tabler/icons-react"
import type { Prisma } from "@tfg/db"
import { Button, ActionIcon, Select } from "@tfg/ui"

import { FiltersSection } from "~/pages/Brand/OrganizationSettings/ProductPages/DisplaySettingsCrud/FiltersForm/FiltersSection.tsx"
import { SplitButton } from "~/pages/Brand/OrganizationSettings/ProductPages/DisplaySettingsCrud/FiltersForm/SplitButton.tsx"

interface Props {
  filters: Prisma.JsonObject
  setFilters: (filters: Prisma.JsonObject) => void
  logicalKey: string
  value: Prisma.JsonArray
}

export const FiltersLogicalSection = ({
  filters,
  setFilters,
  logicalKey,
  value,
}: Props) => {
  return (
    <Stack gap="xs">
      <Group gap={3} align="center">
        <SplitButton
          onClick={() => {
            filters = { AND: [filters] }
            setFilters(filters)
          }}
        />
        <Select
          label="Logical link"
          data={[
            {
              value: "AND",
              label: "AND",
            },
            {
              value: "OR",
              label: "OR",
            },
            {
              value: "NOT",
              label: "NOT",
            },
          ]}
          value={logicalKey}
          clearable={false}
          onChange={(input) => {
            if (input) {
              filters[input] = filters[logicalKey]
              delete filters[logicalKey]
              setFilters(filters)
            }
          }}
        />
        <ActionIcon
          type="delete"
          onClick={() => {
            delete filters[logicalKey]
            setFilters(filters)
          }}
        />
      </Group>
      <Grid>
        <Grid.Col span={1} />
        <Grid.Col span={11}>
          <Stack gap="xs">
            {value.map((filter, index) => {
              return (
                <FiltersSection
                  key={index}
                  filters={Object(filter)}
                  setFilters={(input) => {
                    value[index] = input
                    filters[logicalKey] = value
                    setFilters(filters)
                  }}
                />
              )
            })}
            <Button
              style={{ alignSelf: "flex-start" }}
              variant="tertiary"
              radius={50}
              size="xs"
              icon={<IconPlus />}
              onClick={() => {
                value.push({ "": { equals: "" } })
                filters[logicalKey] = value
                setFilters(filters)
              }}
            >
              Add filter
            </Button>
          </Stack>
        </Grid.Col>
      </Grid>
    </Stack>
  )
}
